export class FlcBaseLayer {

  constructor(
    public title?: string,
    public minZoom?: number,
    public maxZoom?: number,
  ) {}

}
